import React, { useEffect, useState } from "react";
import { Calendar, FileText } from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import moment from "moment";
import { getRecentSubscriptionActivities } from "../../../services/apiservices/support";
import Spinner from "../../../components/ui/spinner";

const RecentActivity = ({ dateFilter }) => {
  const [recentActivity, setRecentActivity] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setRecentActivity();
    setLoading(true);
    getRecentSubscriptionActivities(5, dateFilter).then((data) => {
      setRecentActivity(data);
      setLoading(false);
    });
  }, [dateFilter]);

  return (
    <Card className="bg-[#2c3440] dark:bg-[#1A1F2C]  text-white border-none shadow-lg hover:shadow-xl transition-all lg:col-span-1 p-24 h-[500px] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <CardHeader className="pb-8">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl font-bold text-white flex items-center">
            <Calendar className="h-5 w-5 mr-8 text-[#9b87f5]" />
            Recent Activity
          </CardTitle>
          <Button variant="link" className="text-[#1EAEDB]" asChild>
            <a href="/accounts" style={{ color: "#1EAEDB" }}>
              View All
            </a>
          </Button>
        </div>
      </CardHeader>
      <CardContent className="h-[calc(100%-4rem)] overflow-auto">
        <div className="space-y-4">
          {loading ? (
            <Spinner size="lg" />
          ) : (
            recentActivity?.map((item) => (
              <div key={item} className="flex p-12 bg-[#232834] rounded-lg">
                <div className="mr-12 bg-[#3c4351] p-8 rounded-md">
                  <FileText className="h-5 w-5 text-[#9b87f5]" />
                </div>
                <div>
                  <p className="font-medium">Account {item?.type}</p>
                  <p className="text-sm text-gray-400">
                    {item?.company} •{" "}
                    {moment(item?.time * 1000).format("h:mm:ss A")} • $
                    {(item?.amount)}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default RecentActivity;
